import $ from "jquery";

class Modal {
    constructor() {
        this.menu = {
            toggler: $('#menu-toggler'),
            main: $('#main-menu')
        };

        this.modal = {
            toggler: $('.btn-modal'),
            closer: $('[data-modal] #closer'),
            video: $('.modal-video'),
            youtube: $('[data-modal][data-youtube]'),
        };

        this.video = {
            toggler: $('.btn-video'),
        }

        this.header = $('header');
       
    }

    run() {
        this.toggle();
    }

    toggle(){
        if (this.modal.toggler) {
            this.modal.toggler.each(function(){
                $(this).on('click', function(){
                    var data_modal = $(this).attr('data-target');
                    var modal = $('[id="' + data_modal + '"]');
                    var embed_id = $(this).attr('data-youtube');
                    var src_video = 'https://www.youtube-nocookie.com/embed/'+embed_id;
                    
                    modal.addClass('active')
                 
                    if(modal.hasClass('modal-video')){
                        if(modal.attr('data-youtube')){
                            modal.find('iframe').attr('src',src_video);
                        }
                    }

                    // this.body.toggleClass('overflow-hidden');
                    $('body').addClass('overflow-hidden');
                });
            });

            this.modal.closer.on('click', function(){
                $('body').removeClass('overflow-hidden');
                
                if($('[data-modal].active').hasClass('modal-video')){
                    
                    if($('[data-modal].active').attr('data-youtube')){
                        // setTimeout(function(){
                            $('[data-modal].active iframe').removeAttr('src');
                        // },500);
                    }
                    $('[data-modal].active').removeClass('active');
                } else {
                    $('[data-modal].active').removeClass('active');
                }

            });
        }
    }


}

const modal = new Modal();
export default modal;